import type { Volunteer } from '@/payload-types'

export type VolunteerStatus = NonNullable<Volunteer['status']>

/** Display labels for volunteer statuses. Stored DB values are unchanged. */
export const VOLUNTEER_STATUS_LABELS: Record<VolunteerStatus, string> = {
  Pending: 'Pending',
  Approved: 'Approved',
  Confirmed: 'Confirmed',
  Waitlisted: 'Waitlisted',
  Rejected: 'Not Chosen',
  'Backed Out': 'Backed Out',
}

export function volunteerStatusLabel(status: VolunteerStatus | null | undefined): string {
  if (!status) return ''
  return VOLUNTEER_STATUS_LABELS[status]
}
